export const GET_GENRE_ACTORS = 'getGenreActors'
